import React from "react";
import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "The practice",
    body:
      "I'm passionate about data science and machine learning — the craft of moving from raw, unstructured data to models that hold up under scrutiny. Preprocessing, modelling, evaluation: I care about the whole pipeline, not just the accuracy score.",
  },
  {
    no: "02",
    title: "What I'm looking for",
    body:
      "I'm seeking an apprenticeship on an alternating rhythm — one week in school, two to three weeks in the enterprise. A setup where I can learn deeply and contribute to real production problems at the same time.",
  },
];

const rise = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] },
  }),
};

export const Manifesto = () => {
  return (
    <section id="about" data-testid="about-section" className="border-t border-[#E5E5DF] bg-[#F9F9F7]">
      <div className="mx-auto max-w-[1600px] px-6 py-24 md:px-12 md:py-40">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mb-16 md:mb-28"
        >
          <span className="overline">About — Manifesto</span>
        </motion.div>

        <div className="grid grid-cols-1 gap-x-16 gap-y-16 md:grid-cols-12">
          {chapters.map((c, i) => (
            <motion.div
              key={c.no}
              variants={rise}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              custom={i}
              className={`md:col-span-6 ${i === 1 ? "md:pt-24" : ""}`}
            >
              <div className="flex items-baseline gap-6">
                <span className="font-mono text-sm text-[#5C5C5C]">{c.no}</span>
                <span className="h-px flex-1 bg-[#E5E5DF]" />
              </div>
              <h3 className="mt-8 font-display text-4xl font-medium leading-none tracking-tight md:text-6xl">
                {c.title}
              </h3>
              <p className="mt-8 max-w-lg font-sans text-base leading-relaxed text-[#5C5C5C]">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
